<template>
  <div class="multiple-condition">
    <el-select class="ml-3" v-model="condition" size="small">
      <el-option v-for="item in conditions" :key="item.value" :value="item.value" :label="item.label" />
    </el-select>
  </div>
</template>

<script>
import { EQ, INCLUDED, NOT_EQ, NOT_INCLUDED, NOT_NULL, NULL } from '@/assets/js/config/condition-config'

export default {
  name: 'MultipleCondition',
  data() {
    return {
      conditions: [
        {
          label: '包含',
          value: INCLUDED
        },
        {
          label: '不包含',
          value: NOT_INCLUDED
        },
        {
          label: '等于',
          value: EQ
        },
        {
          label: '不等于',
          value: NOT_EQ
        },
        {
          label: '为空',
          value: NULL
        },
        {
          label: '不为空',
          value: NOT_NULL
        }
      ]
    }
  }
}
</script>

<style scoped></style>
